<script lang="ts" module>
  import type { TooltipContentProps as PrimitiveContentProps } from "#lib/internal/components"
  import type { VariantProps } from "class-variance-authority"
  import type { Snippet } from "svelte"
  import { tooltipContentVariants } from "./variants"

  export type TooltipContentProps = PrimitiveContentProps & {
    variant?: VariantProps<typeof tooltipContentVariants>["variant"]
    class?: string
    children?: Snippet
    arrow?: Snippet
  }
</script>

<script lang="ts">
  import { getUiclContext } from "#lib"
  import { Tooltip as TooltipPrimitive } from "#lib/internal/components"
  import { cn } from "#lib/utils"
  import TooltipArrow from "./TooltipArrow.svelte"

  let {
    variant = "info",
    class: className = undefined,
    side = "top",
    arrow,
    children,
    ...restProps
  }: TooltipContentProps = $props()

  const arrowHeight = $derived(["left", "right"].includes(side) ? "8px" : "6px")

  const v2 = !!getUiclContext()?.v2
</script>

<TooltipPrimitive.Portal>
  <TooltipPrimitive.Content
    class={cn(tooltipContentVariants({ v2, variant }), className)}
    style="--arrow-height: {arrowHeight}"
    {side}
    {...restProps}
  >
    {@render children?.()}
    {#if arrow}
      {@render arrow()}
    {:else}
      <TooltipArrow {side} />
    {/if}
  </TooltipPrimitive.Content>
</TooltipPrimitive.Portal>
